import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BaseService } from 'src/app/core/services/base.service';

export interface OiGroupDialogData {
  title: string;
  function: string;
  postBody: any;
}

export interface OiGroupProcessResponse {
  groupProcessedSuccessfully: boolean;
  activateOutgoingIntegration: boolean;
  outgoingMessageGroupId: number;
}

export interface OiGroupProcessDetails {
  messageId: number;
  messageCode: string;
  messageDesc: string;
  messageStatus: number;
  messageStatusDesc: string;
  messageStatusColor: string;
  sysproResults: {
    type: string;
    value: string;
  }[];
  resultErrors: {
    source: string;
    desc: string;
  }[];
}


@Component({
  selector: 'app-oi-group-process-dialog',
  templateUrl: './oi-group-process-dialog.component.html',
  styleUrls: ['./oi-group-process-dialog.component.scss']
})
export class OiGroupProcessDialogComponent implements OnInit {
  integrationBusy: boolean = true;
  processDetails: OiGroupProcessDetails[] = [];

  constructor(
    public dialogRef: MatDialogRef<OiGroupProcessDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: OiGroupDialogData,
    private baseService: BaseService
  ) { }

  ngOnInit() {
    this.baseService.executeCommand<OiGroupProcessResponse>(this.data.function, this.data.postBody)
      .subscribe(
        response => {
          this.integrationBusy = false;
          if (response.responseCode !== 0) {
            this.dialogRef.close(response);
          } else {
            if (response.data.groupProcessedSuccessfully || response.data.activateOutgoingIntegration === false) {
              this.dialogRef.close(response);
            } else {
              this.baseService.executeCommand<OiGroupProcessDetails[]>('portal_outgoing_group_summary', response.data)
                .subscribe(detailResponse => {
                  if (response.responseCode === 0) {
                    this.processDetails = detailResponse.data;
                  } else {
                    this.processDetails = [];
                  }
                });
            }
          }
        },
        error => {
          this.integrationBusy = false;
          this.processDetails = [];
        });
  }
}
